<template>
    <div class="forgetPassword">
        <div class="msg">找回密码</div>
        <div class="nav">
            <span
                v-for="(item, index) in nav.arr"
                :key="index"
                :class="nav.active == index ? 'active' : ''"
                @click="nav.active = index"
                >{{ item }}</span
            >
        </div>
        <div class="form" v-if="nav.active == 0">
            <input type="text" v-model="form.sendTo" placeholder="请填写邮箱" />
            <div>
                <input type="text" v-model="form.code" placeholder="请输入邮箱验证码" />
                <span
                    @click="getCode"
                    class="getCode"
                    style="cursor:pointer"
                    >{{getCodeVal}}</span
                >
            </div>
            <input type="text" v-model="form.password" placeholder="请设置您的新密码" />
        </div>
        <div class="btn" v-if="nav.active == 0" @click="confirm">确定</div>

        <div class="other" v-if="nav.active == 1">
            如您的账号已绑定手机号，请选择“手机号找回密码”，其他情况请联系客服客服工作时间:
            每周一至周五 上午8:30-下午17:30
        </div>
    </div>
</template>

<script>
import {findPassword,resetPwd} from '@/api/login'
export default {
    data() {
        return {
            getCodeVal:'获取验证码',
            nav: {
                active: 0,
                arr: ["手机找回密码", "其他方式找回"],
            },
            form:{
                code:'',	//验证码
                sendTo:'',   //邮箱
                password:'',
				uuid:'',
            }
        };
    },
    methods:{
        getCode() {

            if(!this.$utils.yz.isEmail(this.form.sendTo)){
                this.$message({ message: '请输入正确的邮箱1', type: 'warning' });
                return
            }

            if(this.getCodeVal == "获取验证码") {
                this.getCodeVal = "59s"
                let num = 59
                let tirm = setInterval(_=>{
                    num --;
                    if(num <= 1){
                        this.getCodeVal = "获取验证码"
                        clearInterval(tirm)
                    }else{
                        this.getCodeVal =  num + 's'
                    }
                },1000)

				findPassword({
					sendTo:this.form.sendTo
				}).then(res=>{
					if(res.code === 200){
						this.$message({ message: res.msg, type: 'success' });
						this.form.uuid = res.data.uuid
						return
					}
					this.$message({ message: res.msg, type: 'error' });
					clearInterval(tirm)
					this.getCodeVal = "获取验证码"
				})
            }
        },
        confirm(){
            let {code,sendTo,password} = this.form;

            if(!this.$utils.yz.isEmail(sendTo)){ this.$message({ message: '请输入正确的邮箱', type: 'warning' }); return }
            if(!code){ this.$message({ message: '请输入邮箱验证码', type: 'warning' }); return }
            if(!password){ this.$message({ message: '请输入密码', type: 'warning' }); return }

			resetPwd(this.form).then(res=>{
				if(res.code === 200){
					this.$message({ message: '修改成功', type: 'success' })
					setTimeout(_=>{
                        this.$router.replace('/login')
                    },1200)
				}else{
					this.$message({ message: res.msg, type: 'warning' })
				}
			})
        }
    }
};
</script>

<style lang="scss" scoped>
.forgetPassword {
    padding: 0px 70px;
    .msg {
        text-align: center;
        margin: 20px 0;
        font-size: 28px;
    }
    .nav {
        text-align: center;
        margin: 30px 0;
        display: flex;
        span {
            flex: 1;
            padding: 15px 0;
            border: 1px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;
            &.active {
                background-color: #ffffff;
            }
        }
    }
    .form {
        input {
            height: 50px;
            width: 100%;
            padding: 0;
            margin: 0;
            padding-left: 30px;
            box-sizing: border-box;
        }

        > div {
            display: flex;
            align-items: center;
            span {
                white-space: nowrap;
                padding: 0 30px;
            }
        }
        > div,
        > input {
            margin-bottom: 20px;
        }
    }
    .btn {
        padding: 20px;
        text-align: center;
        color: #ffffff;
        background-color: #256dbc;
        cursor: pointer;
    }
}
</style>
